import DragImg from './dragImg.vue';

export default DragImg;



// WEBPACK FOOTER //
// ./src/components/dragImg/index.js